import {getOutlet} from 'reconnect.js';
import * as Cart from 'rev.sdk.js/Actions/Cart';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';

const UserOutlet = getOutlet('user');

const AppActionsOverride = {};

//////////////////////////////////////////////////
// Override existing AppActions
AppActionsOverride.doCustomThing = async (...args) => {
  console.log(args);
};

function getDefaultCheckoutFormSpec() {
  return {
    paymentSubTypes: [
      // Cart.PAYMENT_SUBTYPE.default,
      // Cart.PAYMENT_SUBTYPE.credit,
      // Cart.PAYMENT_SUBTYPE.cod,
      Cart.PAYMENT_SUBTYPE.offline,
      Cart.PAYMENT_SUBTYPE.linepay,
      // Cart.PAYMENT_SUBTYPE.atm,
    ],
    logisticsTypes: [
      Cart.LOGISTICS_TYPE.cvs,
      Cart.LOGISTICS_TYPE.home,
      Cart.LOGISTICS_TYPE.oversea,
    ],
    logisticsSubTypes: {
      [Cart.LOGISTICS_TYPE.cvs]: [
        Cart.LOGISTICS_SUBTYPE.famic2c,
        Cart.LOGISTICS_SUBTYPE.hilifec2c,
        Cart.LOGISTICS_SUBTYPE.unimartc2c,
      ],
      [Cart.LOGISTICS_TYPE.home]: [
        Cart.LOGISTICS_SUBTYPE.SF,
        Cart.LOGISTICS_SUBTYPE.TCAT,
        Cart.LOGISTICS_SUBTYPE.ECAN,
      ],
      [Cart.LOGISTICS_TYPE.oversea]: [
        Cart.LOGISTICS_SUBTYPE.SF_OVERSEA_CN,
        Cart.LOGISTICS_SUBTYPE.SF_OVERSEA_HK,
        Cart.LOGISTICS_SUBTYPE.SF_OVERSEA_MO,
      ],
    },
    invoiceCategories: [Cart.INVOICE_CATEGORY.b2c, Cart.INVOICE_CATEGORY.b2b],
    invoiceCarrierTypes: [
      Cart.INVOICE_CARRIER_TYPE.none,
      Cart.INVOICE_CARRIER_TYPE.ecpay,
      Cart.INVOICE_CARRIER_TYPE.cdc,
      Cart.INVOICE_CARRIER_TYPE.mobile,
    ],
    invoiceTypes: [
      Cart.INVOICE_TYPE.B2B,
      Cart.INVOICE_TYPE.B2C_DONATE,
      Cart.INVOICE_TYPE.B2C_NPC,
      Cart.INVOICE_TYPE.B2C_PHONE_CARRIER,
      Cart.INVOICE_TYPE.B2C_PROVIDER,
    ],
  };
}

AppActionsOverride.onCartLoaded = (...args) => {
  const cart = args[0];

  const checkoutFormSpec = getDefaultCheckoutFormSpec();

  const defaultUser = {
    buyer_name: cart.buyer_name || UserOutlet.getValue().data.name || '',
    buyer_email: cart.buyer_email || UserOutlet.getValue().data.email || '',
    buyer_phone: cart.buyer_phone || UserOutlet.getValue().data.phone || '',
    buyer_zip: cart.buyer_zip || UserOutlet.getValue().data.zip || '',
    buyer_city: cart.buyer_city || UserOutlet.getValue().data.city || '',
    buyer_district:
      cart.buyer_district || UserOutlet.getValue().data.district || '',
    buyer_address:
      cart.buyer_address || UserOutlet.getValue().data.address || '',
  };

  const updateConfig = {
    ...cart,
    ...defaultUser,
  };

  if (
    updateConfig.payment_subtype !== 'offline' &&
    updateConfig.payment_subtype !== 'linepay'
  ) {
    updateConfig.payment_subtype = 'offline';
  }

  if (!updateConfig.logistics_subtype) {
    updateConfig.logistics_subtype = 'SF';
  }

  return {
    updateConfig,
    checkoutFormSpec,
  };
};

export default AppActionsOverride;

//////////////////////////////////////////////////
// Extra custom actions
function sayHello() {
  console.log('hello, this is custom section, custom it');
}

export {sayHello};
